// Imports
import { createGlobalStyle } from 'styled-components/macro';


// Global style
const WhiteBackground = createGlobalStyle`
	body {
		background: #fff !important;
	}
`;

export default WhiteBackground;
